import FeaturedSolutions from "../../../components/FeaturedSolutions";
import HorizontalLine from "../../../components/icons/HorizontalLine";
import LogoMini from "../../../components/icons/LogoMini";
import Fly from "../../../assets/img/Featured/fly-tap-pay-tall.png";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useCallback } from "react";
import { useData } from "../../../context/DataProvider";
import { Header } from "../../../components/Header";
const CartPage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const navigate = useNavigate();
    return(
        <div className="page cartPage">
            <Header />
            <div className="page-header">Golf Course</div>
            <div className="text-wrapper">
                <div className="top">
                    <div className="topic-header">Beverage Cart</div>
                    <HorizontalLine />
                </div>
                <div className="std-text">
                    Nothing pairs better with a 300-yard drive than an
                    icy cold beverage. With IG Fly, our new all-in-one
                    handheld POS, cart attendants can quickly take
                    and fulfill golfers' orders followed by seamless fast
                    payment to ensure they are back on the course in
                    record time.
                </div>
            </div>

            <FeaturedSolutions>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Golf - Beverage Cart", "IG Fly");
                    addFlow("IG Fly");
                    navigate("/solutions/ig-fly")}}>
                    <img src={Fly} alt="" />
                    <div className="item-head">
                        <LogoMini />
                        IG Fly
                    </div>
                    
                </div>
            </FeaturedSolutions>
        </div>
    )
}
export default CartPage;